<template>
<v-container fill-height>
  <v-layout align-center> 
    <v-flex xs12 sm6 offset-sm3>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-container align-center class="materialized_ctn__form">
            <v-card-text>
              <v-text-field :label="$t('message.Username')" v-model="username" :rules="nameRules" required @keyup.enter="login"></v-text-field>
              <v-text-field :label="$t('message.Password')" v-model="password" :rules="passwordRules" :type="'password'" required @keyup.enter="login"></v-text-field>
            </v-card-text>
            <v-card-actions style="justify-content: space-between;">
                <router-link to="/account/create" class="login-link"  >{{ $t('message.CreateAccount') }}</router-link>
                <v-btn v-on:click="login" color="secondary" class="materialized">{{ $t('message.Login') }}</v-btn>
            </v-card-actions>

              <v-snackbar
                v-model="showmessage"
                bottom="bottom"
                right="right"
                :timeout="6000"
                >
                <span>{{ alertMessage }}</span>
                <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
            </v-snackbar> 
          </v-container>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>
</template>



<script>
import Account from "../../services/Account.js";
import { mapGetters } from "vuex";

export default {
  name: "AccountLogin",
  data() {
    return {
      valid: true,
      username: "",
      nameRules: [v => !!v || "Username is required"],
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      secret: "10a707c50f4511e7ad2110c37b9e1954",
      secretRules: [v => !!v || "Secret is required"],
      client: "team.com",
      clientRules: [v => !!v || "Client is required"],
      showmessage: false,
      alertMessage: ""
    };
  },
  methods: {
    login: function() {
      if (!this.$refs.form.validate()) return;

      localStorage.setItem("username", this.username);
      Account.requestToken({
        username: this.username,
        password: this.password,
        secret: this.secret,
        client: this.client
      }).then(
        function(response) {
          response.data.secret = this.secret;
          response.data.client = this.client;
          this.$store.dispatch("LOGIN", response.data);
          this.$router.push("/home");
        }.bind(this)
      ).catch(() => {
        this.alertMessage = "The login has failed with one of this issue: 1. Incorect user or pasword, 2. your account is locked, 3. email confirmation is required";
        this.showmessage = true;
      });
    },
    refresh: function() {
      Account.refreshToken().then(
        function(response) {
          response.data.secret = this.secret;
          response.data.client = this.client;
          this.$store.dispatch("LOGIN", response.data);
          this.$router.push("/home");
        }.bind(this)
      )
    }
  },
  computed: {
    ...mapGetters(["authData"])
  },
  created() {
    if (this.authData.secret) this.secret = this.authData.secret;

    if (this.authData.client) this.client = this.authData.client;

    if (this.authData.username) this.username = this.authData.username;

    if (
      this.authData &&
      this.authData.access_token &&
      this.authData.access_token.length > 10
    ) {
      this.$router.push("/home");
    }
  }
};
</script>

<style scoped>
input:-webkit-autofill {
    background-color: #fff !important;
}

.login-link {
  text-decoration: none;
  font-weight: bold;
  color: var(--v-primary-base)
}
</style>


<style lang="stylus">
@import '../../stylus/main.styl';

.container {
  max-width: 1000px;
}

#app {
  height: 100vh;
}

.v-input__control {
  color: $login-material-color;
}

.materialized {
  background: $login-material-color;
  color: $login-text-color;
}

.v-messages__message {
  color: $materialized-error-color;
}

.materialized_ctn__form {
  background: #fff;
}

// body {
// background: url(../../assets/icons/bg.jpg)
// }
.v-card__media__content {
  // background: rgba(0, 0, 0, 0) url(../../assets/icons/logincard.png) no-repeat scroll center center / cover;
}

</style>
 